import React from 'react'
import { AuthorImage, GuestAuthorTag } from '../../../atoms'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'

interface QuoteDetails {
  quote: string
  imgUrl: string
  authorName: string
  authorDesg: string
  authorUrl: string
  companyLogoUrl: string
}

interface GuestQuoteSnippetProps {
  name: string
  jsonBody: QuoteDetails
}

const GuestQuoteSnippet = ({ jsonBody, name }: GuestQuoteSnippetProps) => {
  try {
    return (
      <div className='guest-quote-snippet' id={removeWhitespaceAndSpecialChars(name)}>
        <div className='guest-quote-snippet__content'>
          <div className='guest-quote-snippet__content__quote'>
            <span className='guest-quote-snippet__content__quote__text'>“{jsonBody.quote}”</span>
          </div>
          <div className='guest-quote-snippet__content__author'>
            <div className='guest-quote-snippet__content__author__details'>
              <div className='guest-quote-snippet__content__author__details__mask'>
                <AuthorImage src={jsonBody.imgUrl} variant='small' />
              </div>
              <div className='guest-quote-snippet__content__author__details__text'>
                <div className='guest-quote-snippet__content__author__details__text__name-tag'>
                  <a
                    className='guest-quote-snippet__content__author__details__text__name-tag__name'
                    href={jsonBody.authorUrl}
                  >
                    {jsonBody.authorName}
                  </a>
                  <div className='guest-quote-snippet__content__author__details__text__name-tag__tag'>
                    {jsonBody.companyLogoUrl && (
                      <GuestAuthorTag companyLogoUrl={jsonBody.companyLogoUrl} />
                    )}
                  </div>
                </div>
                <div className='guest-quote-snippet__content__author__details__text__designation'>
                  {jsonBody.authorDesg}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default GuestQuoteSnippet
